module.exports = __webpack_public_path__ + "static/Portrait-of-Anders-min-9765f7363567bc92a700a005d00d8158.webp";